import { useCallback, useRef } from 'react';

// Returns a ref to be put on an element, and a function which will scroll to that element
export const useScrollIntoView = <T extends HTMLElement>(
  block: ScrollLogicalPosition = 'start',
) => {
  const ref = useRef<T | null>(null);

  const scrollIntoView = useCallback(() => {
    // We need to check that ref.current.scrollIntoView exists because it's missing in JSDOM
    if (ref.current?.scrollIntoView) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: block });
    }
  }, [block]);

  return [ref, scrollIntoView] as const;
};
